module.exports = __webpack_public_path__ + "media/Goals/SaveWater-a941a842.svg";